import { render, staticRenderFns } from "./UpdateResourceBookingPage.vue?vue&type=template&id=1597cf6a&scoped=true"
import script from "./UpdateResourceBookingPage.vue?vue&type=script&lang=js"
export * from "./UpdateResourceBookingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1597cf6a",
  null
  
)

export default component.exports